import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { catchError, map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

import { Subscription } from 'rxjs';
import { SystemStatus, SystemStatusGQL } from 'src/app/shared/graphql';
import { TelemetryService } from './telemetry.service';
import { TelemetryAction } from '../interfaces/telemetry/telemetry-action';
import { SeverityError } from '../enum/severity-error';
import { AdminV3Service } from './admin-v3.service';
import { routesV3 } from '../const/routes-config';


@Injectable({
  providedIn: 'root'
})
export class MaintenanceProblemService {

  systemStatus!: SystemStatus;
  subSystemStatus!: Subscription;

  constructor(private apollo: Apollo, private systemStatusGql: SystemStatusGQL,
    private router: Router, private telemetryService: TelemetryService, private adminV3Service: AdminV3Service) { }

  getMaintenanceProblemConfig(): Promise<any> {
    return new Promise((resolve) => {

      // GET DISTRICT IN STORAGE
      const districtId = this.adminV3Service.getDistrictId();

      const query = this.apollo.watchQuery<any>({
        query: this.systemStatusGql.document,
        variables: { districtId: districtId },
        fetchPolicy: 'network-only'
      });

      // TELEMETRY DATA
      const telemetryActionData = {
        action: this.telemetryService.getOperationName(this.systemStatusGql),
        variables: { districtId: districtId }
      } as TelemetryAction;

      this.subSystemStatus?.unsubscribe();

      this.subSystemStatus = query.valueChanges
        .pipe(
          map(({ data }) => {
            this.subSystemStatus?.unsubscribe();

            // TREAT PROBLEM
            if (data?.systemStatus?.problem) {
              this.telemetryService.logError(data.systemStatus.problem, telemetryActionData, SeverityError.ERROR);
              resolve(null);
            } else {
              this.systemStatus = data?.systemStatus?.status;
              const healthy = this.systemStatus?.healthy;

              if (!healthy) {
                const systemStatusStorage = {
                  description: this.systemStatus?.description ?? '',
                  descriptionStyle: this.systemStatus?.descriptionStyle ?? '',
                  eventProblemStart: this.systemStatus?.eventStartedAt ?? ''
                };

                telemetryActionData.variables['data']= this.systemStatus;
                this.telemetryService.logError({message: 'Show splash screen'}, telemetryActionData, SeverityError.INFO);

                // Save as a single JSON string
                sessionStorage.setItem('systemStatusConfig', JSON.stringify(systemStatusStorage));
              } else {
                sessionStorage.removeItem('systemStatusConfig');
              }

              return resolve(healthy);
            }
          },
            catchError((error) => {
              // LOG ERROR IN GRAFANA
              this.telemetryService.logError(error, telemetryActionData, SeverityError.ERROR);
              resolve(null);
              return error;
            }))).subscribe();
    });
  }

  checkMaintenanceRedirect(): void {
    void this.getMaintenanceProblemConfig().then((resolve) => {
      if (!resolve) {
        // REDIRECT TO DASHBOARD IF SYSTEM IS NOT MAINTENANCE
        void this.router.navigate([routesV3.systemerror.selector]);
      }
    });
  }

}
